// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Mauritius from '../_raw/flag/icon_flag_mauritius.png';

export default () => <img src={Mauritius} alt="Mauritius" />;
